
export const WEBSITE = {
    DOMAIN: 'www.petloversllc.com'
}